import { Component, createRef } from "react";

import { EditorSyncFiles } from "../EditorSync";
import { EditorPlayerProgress } from "./types";

interface Props {
  src: string;
  loop: boolean;
  playing: boolean;
  paused: boolean;
  muted: boolean;
  progress?: (progress: EditorPlayerProgress) => unknown;
  ended?: () => void;
  files: EditorSyncFiles;
}

export class EditorPlayerVideo extends Component<Props> {
  private ref = createRef<HTMLVideoElement>();

  override componentDidMount(): void {
    try {
      const element = this.element();

      if (!element) {
        return;
      }

      element.src = this?.props?.files?.[this.props.src];
    } catch (error) {
      console.error(error);
    }
  }

  override componentDidUpdate(prevProps: Props) {
    const element = this.element();

    if (
      prevProps.src !== this.props.src ||
      (prevProps.playing && !this.props.playing)
    ) {
      const element = this.element();

      if (!element) {
        return;
      }

      element.src = this?.props?.files?.[this.props.src];
    } else if (!prevProps.playing && this.props.playing && !this.props.paused) {
      try {
        element?.play();
      } catch (error) {
        console.error(error);
      }
    } else if (!prevProps.paused && this.props.paused) {
      element?.pause();
    } else if (prevProps.paused && !this.props.paused) {
      try {
        element?.play();
      } catch (error) {
        console.error(error);
      }
    }
  }

  override componentWillUnmount(): void {
    const element = this.element();

    if (!element) {
      return;
    }

    element.remove();
  }

  element() {
    return this.ref.current;
  }

  progress = () => {
    if (!this.props.progress) {
      return;
    }

    const element = this.element();
    const position = element?.currentTime;
    const duration = element?.duration;

    this.props?.progress({
      position,
      duration,
      transition: !this.props.loop && !element?.ended,
      loop: this.props.loop,
      ended: element?.ended,
    });
  };

  ended = () => {
    this.props.ended?.();
  };

  override render() {
    return (
      <video
        ref={this.ref}
        loop={this.props.loop}
        muted={this.props.muted}
        autoPlay={false}
        preload="auto"
        className="w-100 h-100 w-full h-full"
        style={{
          objectFit: "cover",
          objectPosition: "center",
        }}
        onLoadedData={() => {
          try {
            if (this.props.playing && !this.props.paused) {
              this.element()?.play();
            }
          } catch (error) {
            console.error(error);
          }
        }}
        onDurationChange={this.progress}
        onTimeUpdate={this.progress}
        onEnded={this.props.ended}
        controls={false}
      />
    );
  }
}

export default EditorPlayerVideo;
